import React, { lazy, Suspense } from "react";

//import DefaultLoader from "../utilities/loaders/DefaultLoader";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const ProjectManagementContent = lazy(
  () => import("./ProjectManagementContent"),
);

const ProjectManagement = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <ProjectManagementContent />
    </Suspense>
  );
};

export default ProjectManagement;
